import { motion } from 'framer-motion';

export const SectionHeader = ({ eyebrow, title, description, align = 'left', testId }) => (
    <div
        className={`max-w-2xl ${align === 'center' ? 'mx-auto text-center' : ''}`}
        data-testid={testId}
    >
        {eyebrow && (
            <div
                className={`flex items-center gap-3 mb-3 ${align === 'center' ? 'justify-center' : ''}`}
            >
                <span className="accent-bar" />
                <span className="text-[hsl(var(--accent))] font-semibold text-xs uppercase tracking-widest">
                    {eyebrow}
                </span>
            </div>
        )}
        <motion.h2
            initial={{ opacity: 0, y: 8 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4 }}
            viewport={{ once: true, margin: '-80px' }}
            className="font-display text-3xl sm:text-4xl font-semibold tracking-tight text-foreground"
        >
            {title}
        </motion.h2>
        {description && (
            <motion.p
                initial={{ opacity: 0, y: 6 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: 0.05 }}
                viewport={{ once: true, margin: '-80px' }}
                className="mt-3 text-muted-foreground text-base leading-relaxed"
            >
                {description}
            </motion.p>
        )}
    </div>
);

export default SectionHeader;
